import { useSelector } from 'react-redux';
import { selectWhitelabelCopies } from 'selectors/whitelabelSelectors';

/**
 * useWhitelabelCopies hook. Return whitelabel copy strings from Redux state.
 * @returns {object} Copies configuration object.
 */
const useWhitelabelCopies = () => {
  const copies = useSelector(selectWhitelabelCopies);
  return copies;
};

export default useWhitelabelCopies;
